module.exports = __webpack_public_path__ + "static/media/news_merima.f4d01bee.png";